import styled from 'styled-components'
import Card from '../juegos/card.jsx';
import { formatFecha } from "../../services/utilities.js"



const Container=styled.div`
	display:flex;  
  border-radius:5px 15px 15px 5px;    
  background-color:black;
  height:29vh;
  min-height:175px; 
  color:white;
  z-index:1;
  transition:width 500ms;
  min-width:530px;
  width:42vw;
  overflow:hidden;
  position:relative;
  margin:15px

  

`;
const ContainerCard=styled.div`
  min-width:175px;
  width:35%;
  height:100%
`;


const Titulo=styled.div`
  font-size:18px;
  font-family:'Poppins', 'sans-serif';
  text-align:center;
`;


const CardDescription=styled.div`
  color:white;
  position:relative;  
  display:flex;
  flex-direction:column;
  justify-content:space-evenly;
  align-items:center;
  width:65%;
  min-width:200px;
  height:100%;
  
`;

const Overlay=styled.div`
  background-position:center;
  background-size:cover;
  position:Absolute;
  width:110%;
  height:100%;
  z-index:-1;
  opacity: 0.2;


`;


export default function GameCardReventa(props){
	let {reventa } = props;
	console.log("reventa")
	console.log(reventa)
	return(
		<Container >
             
			        <ContainerCard>
                <Card consola={reventa.consola} poster={reventa.Cuenta_Juego.Juego.poster}/>
              </ContainerCard>
              {reventa?
                <CardDescription>
                <Overlay style={{backgroundImage:`url(${reventa.Cuenta_Juego.Juego.poster})`}}/>                    
                <Titulo >
                  <b >{reventa.Cuenta_Juego.Juego.nombre}</b>
                </Titulo>
                	<div>fecha de publicacion : {formatFecha(reventa.fecha_publicar)}</div>
                    <div>tipo de cuenta :{reventa.tipo_cuenta===1?" Primaria":" Secundaria"}</div>
                </CardDescription>:null}
		</Container>)
}